import BoxScoreCalculator from "../../../../sports/football/stats/box-score-calculator";

export const PeriodStatSerializer = {
    // periodStat param will comes from home/awayTeamStats.periods, driveSummary comes from boxscore object
    // No simple way to determine period score currently, need to use a isHomeTeam param and pull the last periods applicable drive score from boxscores driveSummary array.
    serialize(periodStat, gameContext, periodScore, miscPossession = 0) {
        const { defense, kicks, offense } = periodStat?.stats || {};
        const { passing, rushing, penalty, total } =
            BoxScoreCalculator.getCombinedDownStats(
                periodStat,
                gameContext.gameConfig.general.downs
            );
        const thirdDownStats =
            BoxScoreCalculator.getThirdDownStatsByTeam(periodStat);
        const fourthDownStats =
            BoxScoreCalculator.getFourthDownStatsByTeam(periodStat);

        const isStartOfSecondHalf = gameContext.isStartOfSecondHalf(
            gameContext.getCurrentPeriod()
        );
        const isEndOfGame = !!gameContext.finalizeSettings;
        const isInRedZone = gameContext.isInRedZone();

        return {
            /* Where do these values comes from? */
            conversionFourthAtt: fourthDownStats.attempted,
            conversionFourthConv:
                fourthDownStats.total + fourthDownStats.touchdowns,
            conversionThirdAtt: thirdDownStats.attempted,
            conversionThirdConv:
                thirdDownStats.total + thirdDownStats.touchdowns,
            // How many times a team was in first down.
            firstDownNo: total,
            // How many times the team made a pass while at first down.
            firstDownPass: passing,
            // How many times the team made a penalty while at first down.
            firstDownPenalty: penalty,
            // How many times the team made a rush while at first down.
            firstDownRush: rushing,
            miscPossession,
            // If game ended with the team at the red zone.
            redZoneEndOfGame: isInRedZone && isEndOfGame,
            // If game went to half time with the team at the red zone.
            redZoneEndOfHalf: isInRedZone && isStartOfSecondHalf,
            redZoneEndOnDowns: 0, // TODO
            redZoneEndOnFga: 0, // TODO
            redZoneEndOnFumble: 0, // TODO
            redZoneEndOnIntCpt: 0, // TODO
            redZoneFgsMade: kicks?.fieldGoalRedzone?.completed || 0,
            redZoneOnSideAttempt: 0, // TODO
            redZoneOnSideRecover: 0, // TODO
            redZonePassingTds: offense?.pass?.touchdowns || 0,
            redZonePointsScored: 0, // TODO
            redZoneRushingTds: offense?.rush?.touchdowns || 0,
            redZoneTimeScored: 0, // TODO
            score: periodScore
        };
    }
};
